import React, { useState ,useEffect} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import UndoIcon from '@mui/icons-material/Undo';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {
    CautionButton,
    GrayButton
} from '../../css/CSS.js';

const Img = styled('img')({
});

export default function InspectionDelConfirm(props) {
    const [open, setOpen] = useState(false)

    const handleClose = () => {
        props.cancelClick();
    };

    const handleOpen = () => {
        props.deleteClick();
    }

    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "90%", // 画面幅の8割
                        maxWidth: "800px", 
                    },
                }}
            >
                <Grid container direction="row"
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        p: 3,
                        backgroundColor: "#1976d2",
                    }}>
                    {props.contentType === 0 ?
                        <DialogTitle id="alert-dialog-title" sx={{ fontSize: '2rem', color: '#ffffff', py: 0 }}>
                            {"外観画像削除確認"}
                        </DialogTitle>
                        : props.contentType === 1 ?
                            <DialogTitle id="alert-dialog-title" sx={{ fontSize: '2rem', color: '#ffffff', py: 0 }}>
                                {"添付画像削除確認"}
                            </DialogTitle>
                            : props.contentType === 2 ?
                                <DialogTitle id="alert-dialog-title" sx={{ fontSize: '2rem', color: '#ffffff', py: 0 }}>
                                    {"添付ファイル削除確認"}
                                </DialogTitle>
                                : null
                    }

                </Grid>
                <DialogContent>
                    <Typography sx={{ fontSize: '1.5rem' }}>
                        下記ファイルを削除します。
                    </Typography>
                    {props.contentType !== 2 ?
                        <Grid container>
                            <Grid container item
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: '400px',
                                    width: '100%',
                                    bgcolor: '#D8DBDD',
                                    m: 2
                                }}>
                                <Img alt='' src={props.src} sx={{ maxHeight: '100%', maxWidth: '100%' }} />
                            </Grid>
                            <Grid container direction="row"
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                {/*<Typography>*/}
                                {/*    {props.name}*/}
                                {/*</Typography>*/}
                            </Grid>
                        </Grid>
                        :
                        <Grid container
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                height: '150px',
                                width: '500px',
                                //bgcolor: '#D8DBDD',
                                m: 2
                            }}>
                            <Typography sx={{fontSize:'1.5rem'} }>
                                {props.name}
                            </Typography>
                        </Grid>
                    }
                </DialogContent>
                <DialogActions>
                    <Grid container
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2
                        }}>
                        <GrayButton variant="contained" size="large" onClick={handleClose}
                            sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                            <UndoIcon sx={{ mr: 2, fontSize: '2rem' }} />
                            キャンセル
                        </GrayButton>
                        <CautionButton variant="contained" size="large" onClick={handleOpen}
                            sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                            <DeleteForeverIcon sx={{ mr: 2, fontSize: '2rem' }} />確定
                        </CautionButton>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>
    );
}